import React, { useState, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { imgUrl } from 'src/actions/types';

// --- ACTION CREATORS ---
import { getAllDoctors } from '../../actions/doctorActions';
import { getAllLikesByDoctor } from '../../actions/likeDislikeActions';
import { getAllFavourites, deleteFavourite } from 'src/actions/favouritesActions';
import { fetchSpecialities } from 'src/actions/specialityAction';
import { getAllUsers } from "../../actions/loginAction"; // Naya Import
import { getScheduleData } from "../../actions/scheduleActions"; // Naya Import
import { getReviewsByLoggedInPatient } from "../../actions/reviewActions"; // Naya Import

// --- HELPER FUNCTIONS ---
const getExperienceYears = (doctor) => {
    if (!doctor?.Experiences?.length) return 0;
    const currentYear = new Date().getFullYear();
    return doctor.Experiences.reduce((total, exp) => {
        const startYear = parseInt(exp.ExpFrom, 10);
        if (!startYear) return total;
        const endYear = parseInt(exp.ExpTo, 10) || currentYear;
        const duration = endYear - startYear;
        return total + (duration > 0 ? duration : 1);
    }, 0);
};

// --- DOCTOR CARD COMPONENT ---
// const DoctorCard = ({ doctor, handleProfile, handleBooking, onToggleFavourite, favouriteInProgress, specialitySearchIndex }) => {
//     const isEnabled = doctor.app_status !== 'disabled';

//     const specialityLogoUrl = useMemo(() => {
//         if (!doctor.Specializations?.[0]?.Specialization || !specialitySearchIndex || specialitySearchIndex.length === 0) {
//             return null;
//         }
        
//         const doctorSpecialization = doctor.Specializations[0].Specialization.toLowerCase();
//         let bestMatch = { score: 0, logoUrl: null };

//         specialitySearchIndex.forEach(indexEntry => {
//             let currentScore = 0;
//             indexEntry.keywords.forEach(keyword => {
//                 if (doctorSpecialization.includes(keyword)) {
//                     currentScore += keyword.length;
//                 }
//             });
//             if (currentScore > bestMatch.score) {
//                 bestMatch = { score: currentScore, logoUrl: indexEntry.logoUrl };
//             }
//         });
//         return bestMatch.logoUrl;
//     }, [doctor.Specializations, specialitySearchIndex]);

//     return (
//         <div className={`doctor-card h-100 ${!isEnabled ? 'disabled' : ''}`}>
//             <div className="doctor-card-img-wrapper">
//                 <Link to={`/Doctorprofile/${doctor.hospitalID}`}>
//                     <img className="doctor-card-img" alt={`Dr. ${doctor.firstName} ${doctor.lastName}`} src={doctor.uploadPhoto ? `${imgUrl}${doctor.uploadPhoto}` : '/assets/img/doctors/default.jpg'} loading="lazy" />
//                 </Link>
//                 {isEnabled && (
//                     <button
//                         className="ml-3 favourite-btn favourited"
//                         onClick={(e) => { e.stopPropagation(); onToggleFavourite(doctor.hospitalID); }}
//                         disabled={favouriteInProgress === doctor.hospitalID}
//                         title="Remove from Favourites"
//                     >
//                         <i className="fas fa-heart"></i>
//                     </button>
//                 )}
//             </div>
//             <div className="doctor-card-content">
//                 <div className="doctor-card-body">
//                     <h5 className="doctor-card-title">
//                         <Link to={`/Doctorprofile/${doctor.hospitalID}`}>
//                             Dr. {doctor.firstName} {doctor.lastName}
//                         </Link>
//                     </h5>
//                     <div className="d-flex align-items-center mb-2">
//                         {specialityLogoUrl && <img src={specialityLogoUrl} alt={doctor.Specializations?.[0]?.Specialization} className="speciality-logo-icon" loading="lazy" />}
//                         <p className="doctor-card-speciality mb-0">{doctor.Specializations?.[0]?.Specialization || 'General Physician'}</p>
//                     </div>
//                     <div className="doctor-card-stats">
//                         {doctor.recommendationPercentage > 0 && (
//                             <span className="recommendation">
//                                 <i className="far fa-thumbs-up"></i> {doctor.recommendationPercentage}% Recommended
//                             </span>
//                         )}
//                     </div>
//                     <ul className="doctor-card-details list-unstyled">
//                         <li><i className="fas fa-map-marker-alt" /> {doctor.CDCity || 'N/A'}</li>
//                         {doctor.totalExperience > 0 && <li><i className="fas fa-award" /> {doctor.totalExperience} years experience</li>}
//                         {doctor.PricingOnline && <li><i className="far fa-money-bill-alt" /> ₹{doctor.PricingOnline} Fee</li>}
//                     </ul>
//                 </div>
//                 {isEnabled && (
//                     <div className="doctor-card-footer">
//                         {/* The w-100 classes are removed here */}
//                         <button className="view-button" onClick={() => handleProfile(doctor.hospitalID)}>View Profile</button>
//                         <button className="book-now-button" onClick={() => handleBooking(doctor.hospitalID)}>Book Now</button>
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// };
const DoctorCard = ({
  doctor,
  handleProfile,
  handleBooking,
  specialitySearchIndex = [],
  onToggleFavourite,
  favouriteInProgress
}) => {
  const specialityLogoUrl = useMemo(() => {
    const doctorSpecialization = (doctor.Specializations?.[0]?.Specialization || "").toLowerCase();
    if (!doctorSpecialization || specialitySearchIndex.length === 0) return null;
    let bestMatch = { score: 0, logoUrl: null };
    specialitySearchIndex.forEach((indexEntry) => {
      let currentScore = 0;
      indexEntry.keywords.forEach((keyword) => {
        if (doctorSpecialization.includes(keyword)) currentScore += keyword.length;
      });
      if (currentScore > bestMatch.score) bestMatch = { score: currentScore, logoUrl: indexEntry.logoUrl };
    });
    return bestMatch.logoUrl;
  }, [doctor.Specializations, specialitySearchIndex]);

  const isEnabled = doctor.app_status === "enabled";

  return (
    <div className={`doctor-card h-100 ${!isEnabled ? "disabled" : ""}`} 
         style={{ cursor: isEnabled ? "pointer" : "default", width: '100%' }}>
      <div className="doctor-card-img-wrapper">
        <img className="doctor-card-img" alt="Doctor"
             src={doctor.uploadPhoto ? `${imgUrl}${doctor.uploadPhoto}` : "assets/img/doctors/default.jpg"} />
        
        <div className={`availability-badge ml-3 mb-1 ${doctor.isAvailableToday ? "available" : "unavailable"}`}>
          <i className={`fas ${doctor.isAvailableToday ? "fa-check-circle" : "fa-times-circle"}`}></i>
          {doctor.isAvailableToday ? "Available Today" : "Unavailable"}
        </div>

        <button className="favourite-btn favourited" 
                disabled={favouriteInProgress === doctor.hospitalID}
                onClick={(e) => { e.stopPropagation(); onToggleFavourite(doctor.hospitalID); }}>
          <i className="fas fa-heart"></i>
        </button>
      </div>

      <div className="doctor-card-content">
        <div className="doctor-card-body">
          <h5 className="doctor-card-title">
             <a href="#" onClick={(e) => { e.preventDefault(); isEnabled && handleProfile(doctor.hospitalID); }}>
                Dr. {doctor.firstName} {doctor.lastName}
             </a>
          </h5>
          
          <div className="d-flex align-items-center mb-2">
            {specialityLogoUrl && <img src={specialityLogoUrl} className="speciality-logo-icon" alt="icon" />}
            <p className="doctor-card-speciality mb-0">{doctor.Specializations?.[0]?.Specialization || "General Physician"}</p>
          </div>

          <ul className="doctor-card-features list-unstyled m-0">
            <li>
              <span className={`feature-tag ${doctor.isInClinicAvailable ? "text-success" : "text-secondary"}`} style={{ textDecoration: doctor.isInClinicAvailable ? 'none' : 'line-through' }}>
                <i className="far fa-money-bill-alt mr-1"></i> Clinic Consultation {doctor.isInClinicAvailable ? `(₹${doctor.PricingOnline || 0})` : ""}
              </span>
            </li>
            <li>
              <span className={`feature-tag ${doctor.isVideoAvailable ? "text-success" : "text-secondary"}`} style={{ textDecoration: doctor.isVideoAvailable ? 'none' : 'line-through' }}>
                <i className="fas fa-video mr-1"></i> Video Consultation {doctor.isVideoAvailable ? `(₹${doctor.PricingVideo || 0})` : ""}
              </span>
            </li>
            <li>
              <span className={`feature-tag ${doctor.isHomeVisitAvailable ? "text-success" : "text-secondary"}`} style={{ textDecoration: doctor.isHomeVisitAvailable ? 'none' : 'line-through' }}>
                <i className="fas fa-house-user mr-1"></i> Home Consultation {doctor.isHomeVisitAvailable ? `(₹${doctor.HomeVisitPricingOnline || 0})` : ""}
              </span>
            </li>
          </ul>

          <div className="doctor-card-stats m-0 mt-2">
            <span className="rating-stars">{renderStars(doctor.averageRating)}</span>
            <span className="rating-count">({doctor.reviewCount || 0})</span>
          </div>
            {doctor.recommendationPercentage > 0 && (
        <>
            <span className="text-success" style={{ fontWeight: '600',  fontSize: '0.85rem' }}>
                Recommended
            </span>
            <span className="stat-divider" style={{ margin: '0 5px', color: '#ccc' }}>|</span>
            <span className="recommendation" style={{ color: '#046525', fontWeight: '600' }}>
                <i className="far fa-thumbs-up"></i> {doctor.recommendationPercentage}%
            </span>
        </>
    )}
          <ul className="doctor-card-details list-unstyled mt-2">
            <li><i className="fas fa-map-marker-alt" /> {doctor.CDCity || "N/A"}</li>
            {doctor.totalExperience > 0 && <li><i className="fas fa-award" /> {doctor.totalExperience} years exp.</li>}
          </ul>
        </div>

        <div className="d-flex justify-content-between gap-2 w-100 mt-2">
          <button className="flex-fill btn btn-success rounded-pill" style={{background: "#046525", border:"none", height: "34px"}} onClick={() => isEnabled && handleProfile(doctor.hospitalID)}>View</button>
          <button className="flex-fill btn btn-primary rounded-pill" style={{background: "#0084d9", border:"none", height: "34px"}} onClick={() => isEnabled && handleBooking(doctor.hospitalID)}>Book</button>
        </div>
      </div>
    </div>
  );
};
// --- YAHAN SE COPY KAREIN ---
const renderStars = (rating = 0) => {
  const fullStars = Math.floor(rating);
  const halfStar = rating % 1 !== 0;
  const totalStars = 5;
  return (
    <>
      {[...Array(fullStars)].map((_, i) => (
        <i key={`full-${i}`} className="fas fa-star" style={{ color: "#f8b400", marginRight: 2 }}></i>
      ))}
      {halfStar && <i className="fas fa-star-half-alt" style={{ color: "#f8b400", marginRight: 2 }}></i>}
      {[...Array(totalStars - fullStars - (halfStar ? 1 : 0))].map((_, i) => (
        <i key={`empty-${i}`} className="far fa-star" style={{ color: "#f8b400", marginRight: 2 }}></i>
      ))}
    </>
  );
};

const convertToMinutes = (timeStr12h) => {
  if (!timeStr12h) return null;
  const parts = timeStr12h.match(/(\d+):(\d+)\s(AM|PM)/);
  if (!parts) return null;
  let [, hour, minute, period] = parts;
  hour = parseInt(hour, 10);
  minute = parseInt(minute, 10);
  if (period === "PM" && hour !== 12) hour += 12;
  if (period === "AM" && hour === 12) hour = 0;
  return hour * 60 + minute;
};

const isTimeOverlapping = (slotA, slotB) => slotA.start < slotB.end && slotA.end > slotB.start;
// --- YAHAN TAK PASTE KAREIN ---
// --- MAIN FAVOURITES COMPONENT ---
const Favourites = (props) => {
    const {
        allDoctors,
        allLikes,
        favourites,
        specialities,
        getAllFavourites,
        deleteFavourite,
        getAllDoctors,
        getAllLikesByDoctor,
        fetchSpecialities,
        loading,
        error
    } = props;
    
    const history = useHistory();
    const patientId = useMemo(() => JSON.parse(localStorage.getItem('loginData') || '{}').hospitalID, []);

    const [unfilteredFavouritedDoctors, setUnfilteredFavouritedDoctors] = useState([]);
    const [filters, setFilters] = useState({ query: '', sortBy: 'none' });
    const [filteredDoctors, setFilteredDoctors] = useState([]);
    const [favouriteInProgress, setFavouriteInProgress] = useState(null);
    // Component ke andar (top par)
const availabilityByDoctorId = useMemo(() => {
    if (!allDoctors.length || !props.templateSlots.length) return {};
    const res = {};
    const today = new Date();
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const dayName = days[today.getDay()];
    const dateStr = today.toISOString().split('T')[0];

    allDoctors.forEach(doc => {
        // Check Days Off
        const isOff = props.daysOff.some(d => d.hospitalID === doc.hospitalID && d.date === dateStr);
        if (isOff) { res[doc.hospitalID] = false; return; }

        // Check Slots
        const slots = props.templateSlots.filter(s => s.hospitalID === doc.hospitalID && s.day === dayName && s.slot !== "DAY_OFF");
        res[doc.hospitalID] = slots.length > 0;
    });
    return res;
}, [allDoctors, props.templateSlots, props.daysOff]);
    // Effect to fetch all necessary data on component mount
    // useEffect(() => {
    //     if (patientId) {
    //         getAllFavourites(patientId);
    //     }
    //     getAllDoctors();
    //     getAllLikesByDoctor({});
    //     fetchSpecialities();
        
    // }, [patientId, getAllFavourites, getAllDoctors, getAllLikesByDoctor, fetchSpecialities]);
    useEffect(() => {
    if (patientId) {
        props.getAllFavourites(patientId);
    }
    // Ye saari API calls zaroori hain naye card ke liye
    props.getAllDoctors();
    props.getAllLikesByDoctor({});
    props.fetchSpecialities();
    props.getAllUsers();           // Status check karne ke liye
    props.getScheduleData({});     // Availability check karne ke liye
    props.getReviewsByLoggedInPatient(); // Reviews/Stars ke liye
}, [patientId]);
    const specialitySearchIndex = useMemo(() => {
        if (!specialities || specialities.length === 0) return [];
        return specialities.map(spec => {
            const name = spec.SpecialitiesName || '';
            return {
                logoUrl: spec.ImageURL ? `${imgUrl}${spec.ImageURL}` : null,
                keywords: name.toLowerCase().split(' ').filter(Boolean)
            };
        });
    }, [specialities]);

    // Effect to process and enhance the list of favourited doctors
    // useEffect(() => {
    //     if (favourites && allDoctors && allLikes) {
    //         const favouritedDoctorIds = new Set(favourites.map(fav => fav.hospitalID));
    //         const favouriteDoctorsList = allDoctors.filter(doctor => favouritedDoctorIds.has(doctor.hospitalID));

    //         const enhancedDoctors = favouriteDoctorsList.map(doctor => {
    //             const likesForThisDoctor = allLikes.filter(l => String(l.hospitalID) === String(doctor.hospitalID));
    //             const totalVotes = likesForThisDoctor.length;
    //             const totalLikes = likesForThisDoctor.filter(l => l.LikeDislike === "1").length;
    //             const recommendationPercentage = totalVotes > 0 ? Math.round((totalLikes / totalVotes) * 100) : 0;
    //             const totalExperience = getExperienceYears(doctor);
    //             return { ...doctor, recommendationPercentage, totalExperience };
    //         });
            
    //         setUnfilteredFavouritedDoctors(enhancedDoctors);
    //     }
    // }, [favourites, allDoctors, allLikes]);
// Favourites.js ke andar is useEffect ko replace karein
useEffect(() => {
    if (favourites && allDoctors && props.userList && props.allLikes) {
        const statusMap = new Map();
        props.userList.forEach(u => {
            if (u.hospitalID) statusMap.set(String(u.hospitalID), u.app_status);
        });

        const favouritedIds = new Set(favourites.map(fav => fav.hospitalID));
        const myList = allDoctors.filter(doc => favouritedIds.has(doc.hospitalID));

        const enhancedDoctors = myList.map(doctor => {
            // 1. Rating/Stars Logic
            const docReviews = props.reviews?.filter(r => r.hospitalID === doctor.hospitalID) || [];
            const totalStars = docReviews.reduce((acc, curr) => acc + (Number(curr.noofStars) || 0), 0);
            const averageRating = docReviews.length > 0 ? totalStars / docReviews.length : 0;

            // 2. Recommendation (%) Logic - YE NAYA HAI
            const likesForThisDoc = props.allLikes.filter(l => String(l.hospitalID) === String(doctor.hospitalID));
            const totalVotes = likesForThisDoc.length;
            const positiveLikes = likesForThisDoc.filter(l => l.LikeDislike === "1").length;
            const recommendationPercentage = totalVotes > 0 ? Math.round((positiveLikes / totalVotes) * 100) : 0;

            return {
                ...doctor,
                averageRating,
                recommendationPercentage, // Ab ye card mein use ho sakega
                reviewCount: docReviews.length,
                app_status: statusMap.get(String(doctor.hospitalID)) || "disabled",
                isAvailableToday: availabilityByDoctorId[doctor.hospitalID] || false,
                totalExperience: getExperienceYears(doctor),
                isInClinicAvailable: doctor.Clinic_status === "Active" || doctor.Clinic_status === "1",
                isHomeVisitAvailable: doctor.Home_status === "Active" || doctor.Home_status === "1",
                isVideoAvailable: doctor.video_status === "Active" || doctor.video_status === "1",
            };
        });
        
        setUnfilteredFavouritedDoctors(enhancedDoctors);
    }
}, [favourites, allDoctors, props.reviews, props.userList, props.allLikes, availabilityByDoctorId]);
    // Effect to apply filters and sorting whenever they change
    useEffect(() => {
        let results = [...unfilteredFavouritedDoctors];
        const lowerCaseQuery = filters.query.toLowerCase().trim();

        if (lowerCaseQuery) {
            results = results.filter(d => 
                `${d.firstName} ${d.lastName}`.toLowerCase().includes(lowerCaseQuery) ||
                (d.CDCity || '').toLowerCase().includes(lowerCaseQuery) ||
                (d.Specializations?.[0]?.Specialization || '').toLowerCase().includes(lowerCaseQuery)
            );
        }

        if (filters.sortBy === 'recommendation_desc') {
            results.sort((a, b) => (b.recommendationPercentage || 0) - (a.recommendationPercentage || 0));
        } else if (filters.sortBy === 'experience_desc') {
            results.sort((a, b) => (b.totalExperience || 0) - (a.totalExperience || 0));
        }

        setFilteredDoctors(results);
    }, [filters, unfilteredFavouritedDoctors]);
    
    // --- HANDLERS ---
    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const handleToggleFavourite = (doctorId) => {
        if (!patientId) {
            history.push('/login');
            return;
        }
        
        const favouriteRecord = favourites.find(f => f.hospitalID === doctorId && String(f.PatientID) === String(patientId));
        if (!favouriteRecord) return;

        setFavouriteInProgress(doctorId);
        deleteFavourite(favouriteRecord.id)
            .then(() => getAllFavourites(patientId))
            .catch(err => console.error("Unfavourite action failed:", err))
            .finally(() => setFavouriteInProgress(null));
    };

    const handleProfile = (hospitalID) => history.push(`/Doctorprofile/${hospitalID}`);
    const handleBooking = (hospitalID) => history.push(`/Booking/${hospitalID}`);

    // --- RENDER LOGIC ---
    if (loading && unfilteredFavouritedDoctors.length === 0) {
        return <div className="container" style={{padding: '50px', textAlign: 'center'}}>Loading Favourites...</div>;
    }

    if (error) {
        if (error) {
            const errorContainerStyle = {
                padding: '50px',
                textAlign: 'center',
                backgroundColor: '#f8d7da',  // Light reddish background
                color: '#721c24',            // Dark red text color
                border: '1px solid #f5c6cb', // Subtle red border
                borderRadius: '8px',         // Rounded corners
                wordWrap: 'break-word'       // Ensures long error messages fit
            };
        
            const errorPreStyle = {
                whiteSpace: 'pre-wrap',      // Preserve formatting, but wrap long lines
                textAlign: 'left',
                marginTop: '15px',
                padding: '15px',
                backgroundColor: 'rgba(0, 0, 0, 0.05)', // Slight background for the error details
                borderRadius: '4px'
            };
        
            return (
                <div className="container" style={{padding: ' 0'}}>
                        <pre style={errorPreStyle}>
                            {JSON.stringify(error, null, 2)}
                        </pre>
                </div>
            );
        }    }

    return (
        <>
            <style>{`
                /* --- Doctor Card Styles --- */
                .doctor-card {
                    background: #fff;
                    border-radius: 12px;
                    overflow: hidden;
                    box-shadow: 0 6px 20px rgba(0,0,0,0.07);
                    display: flex;
                    flex-direction: column;
                    border: 1px solid #e9ecef;
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                    min-height: 420px; /* Ensures all cards have the same height */
                }
                .doctor-card:hover { transform: translateY(-6px); box-shadow: 0 10px 30px rgba(0,0,0,0.1); }
                .doctor-card.disabled { opacity: 0.7; }
                .doctor-card-img-wrapper { position: relative; width: 260px; height: 180px; }
                .doctor-card-img { width: 260px; height: 100%; object-fit: cover; }
            
.doctor-card-img-wrapper {
  width: 100%;
  aspect-ratio: 4 / 3;       /* 4:3 ratio, or use 1.5, or whatever looks best */
  background: #eee;          /* fallback background */
  overflow: hidden;
  border-top-left-radius: 14px; /* match card */
  border-top-right-radius: 14px;
  min-height: 120px;         /* optional, for very small screens */
}

.doctor-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}


                .doctor-card-content { padding: 1rem; flex-grow: 1; display: flex; flex-direction: column; }
                .doctor-card-body { flex-grow: 1; }
                .doctor-card-title { font-size: 1rem; font-weight: 600; margin-bottom: 0.15rem; color: #333; }
                .doctor-card-title a { color: inherit; text-decoration: none; transition: color 0.3s ease; }
                .doctor-card-title a:hover { color: #0084d9; }
                .speciality-logo-icon { width: 20px; height: 20px; margin-right: 8px; object-fit: contain; flex-shrink: 0; }
                .doctor-card-speciality { font-size: 0.85rem; color: #6c757d; font-weight: 500; }
                .doctor-card-stats { display: flex; align-items: center; flex-wrap: wrap; gap: 5px; margin-bottom: 0.75rem; font-size: 0.9rem; color: #6c757d; min-height: 20px; }
                .doctor-card-stats .recommendation { color: #046525; font-weight: 500; }
                .doctor-card-details { list-style: none; padding-left: 0; font-size: 0.85rem; color: #495057; margin: 0 0 1rem 0; }
                .doctor-card-details li { margin-bottom: 4px; display: flex; align-items: center; }
                .doctor-card-details li i { color: #0084d9; margin-right: 8px; width: 14px; text-align: center; }
                .doctor-card-footer { display: flex; gap: 0.5rem; margin-top: auto; border-top: 1px solid #e9ecef; padding-top: 0.75rem; }
                
                /* This rule makes the buttons have equal width */
                .doctor-card-footer .btn {
                    flex: 1;
                    font-weight: 600;
                    padding: 5px 8px;
                    border-radius: 6px;
                    font-size: 0.8rem;
                }
                
                .favourite-btn { position: absolute; top: 10px; right: 10px; background-color: rgba(255, 255, 255, 0.8); border: none; border-radius: 50%; width: 36px; height: 36px; display: flex; align-items: center; justify-content: center; font-size: 18px; transition: all 0.3s ease; backdrop-filter: blur(4px); cursor: pointer; }
                .favourite-btn:hover { transform: scale(1.1); }
                .favourite-btn.favourited { color: #e44d26; }

                /* --- Filter Bar Styles --- */
                .filter-bar { background-color: #f8f9fa; padding: 20px; border-radius: 8px; margin-bottom: 30px; box-shadow: 0 2px 4px rgba(0,0,0,0.05); }
                .filter-controls { display: flex; flex-wrap: wrap; gap: 15px; }
                .filter-group { flex: 3; min-width: 200px; }
                .filter-group.select-group { flex: 1; min-width: 150px; }
                @media (max-width: 767px) { .filter-controls { flex-direction: column; } .filter-group, .filter-group.select-group { min-width: 100%; } }
                .availability-badge { 
    position: absolute; bottom: 5px; left: 10px; padding: 2px 10px; 
    border-radius: 20px; font-size: 0.7rem; color: #fff; display: flex; align-items: center; gap: 4px; 
    z-index: 2;
}
.availability-badge.available { background-color: rgba(25, 135, 84, 0.9); }
.availability-badge.unavailable { background-color: rgba(220, 53, 69, 0.9); }

.feature-tag { font-size: 0.75rem; font-weight: 500; display: block; margin-bottom: 2px; }
.doctor-card-features i { width: 18px; color: #046525; }

.doctor-card-stats { display: flex; align-items: center; gap: 5px; font-size: 0.8rem; }
.rating-stars { color: #f8b400; }

/* Buttons ka gap sahi karne ke liye */
.gap-2 { gap: 0.5rem !important; }
           `}</style>

            <div className="">
                <div className="page-header filter-bar rounded ">
                <div className="row align-items-center">
                    <div className="col">
                        <h4 className="page-title">Favourites</h4>
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/doctor/dashboard">Patient Dashboard</Link></li>
                            <li className="breadcrumb-item active">Favourites</li>
                        </ul>
                    </div>
                </div>
            </div>
                <div className="filter-bar">
                    <div className="filter-controls">
                        <div className="filter-group">
                            <input type="text" name="query" className="form-control" placeholder="Filter by name, speciality, or location..." value={filters.query} onChange={handleFilterChange} />
                        </div>
                        <div className="filter-group select-group">
                             <select name="sortBy" className="form-control" value={filters.sortBy} onChange={handleFilterChange}>
                                <option value="none">Sort By</option>
                                <option value="recommendation_desc">Recommendation</option>
                                <option value="experience_desc">Experience</option>
                            </select>
                        </div>
                    </div>
                </div>
                    <div className='card'>
                <div className='card-body'>
                <div className="row row-grid">
                    {filteredDoctors.length > 0 ? (
                        filteredDoctors.map(doctor => (
                            <div key={doctor.hospitalID} className="col-12 col-sm-6 col-lg-4 col-xl-3 mb-4 d-flex align-items-stretch">
                                <DoctorCard
                                    doctor={doctor}
                                    handleProfile={handleProfile}
                                    handleBooking={handleBooking}
                                    onToggleFavourite={handleToggleFavourite}
                                    favouriteInProgress={favouriteInProgress}
                                    specialitySearchIndex={specialitySearchIndex}
                                     renderStars={renderStars} 
                                />
                            </div>
                        ))
                    ) : (
                        <div className="col-12 text-center" style={{padding: '50px'}}>
                            {!loading && unfilteredFavouritedDoctors.length === 0 ? (
                                <h4>You have not added any doctors to your favourites yet.</h4>
                            ) : (
                                <h4>No favourited doctors match your current filters.</h4>
                            )}
                        </div>
                    )}
                </div>
                </div>
                </div>

            </div>
        </>
    );
}

// --- REDUX CONNECTION ---
const mapStateToProps = (state) => ({
    allDoctors: state.doctorList.doctors,
    allLikes: state.likeDislike.likeDislikes,
    favourites: state.favourites.favourites,
    specialities: state.specialities.specialities || [],
    reviews: state.reviews.reviews || [], // Ye line add karein
    userList: Array.isArray(state.loginReducer?.userList?.data) ? state.loginReducer.userList.data : [],
    templateSlots: state.schedule.templateSlots || [], // Availability ke liye
    daysOff: state.schedule.daysOff || [],
    blockers: state.schedule.blockers || [],
    loading: state.doctorList.loading || state.likeDislike.loading || state.favourites.loading || state.specialities.loading,
    error: state.doctorList.error || state.likeDislike.error || state.favourites.error || state.specialities.error,
});

const mapDispatchToProps = {
    getAllDoctors,
    getAllLikesByDoctor,
    getAllFavourites,
    deleteFavourite,
    fetchSpecialities,
     getAllUsers,          
    getScheduleData,      
    getReviewsByLoggedInPatient, 
};

export default connect(mapStateToProps, mapDispatchToProps)(Favourites);